module.exports = __webpack_public_path__ + "static/mark-cuban-d1fc938158b3a37352bdf29987cbc96d.jpg";